import React from "react";
import { Button, Modal } from "semantic-ui-react";

export default ({ modalData, onConfirm, onCancel }) => {
  return (
    <Modal dimmer="blurring" onClose={(e) => onCancel()} open={modalData.open}>
      {modalData.title && <Modal.Header>{modalData.title}</Modal.Header>}
      {modalData.content && <Modal.Content> {modalData.content}</Modal.Content>}
      <Modal.Actions>
        <Button
          disabled={modalData.loadingConfirm}
          onClick={(e) => onCancel()}
          negative
        >
          Annuler
        </Button>
        <Button
          disabled={modalData.loadingConfirm}
          loading={modalData.loadingConfirm}
          onClick={(e) => onConfirm(modalData.data)}
          positive
        >
          Continuer
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
